import React, { useState, useEffect } from 'react';
import { ActualizarUsuario } from './modalUsuarioActividad';
import { CambiarClave } from '../../comun/modalCambiarClave';
import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";

 
import useTable from "../../useTable"
import axios from 'axios';


const headCells = [
    { id: 'codigo', label: 'CODIGO', width: '10px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
    { id: 'usuario', label: 'USUARIO', width: '150px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
    { id: 'nombreape', label: 'NOMBRES', width: '300px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
    { id: 'accion', label: 'OPCIONES', width: '120px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
]

function TablaUsuarioHacienda() {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [idUsuarioH, setIdUsuarioH] = useState(0);
    const [contar, setContar] = useState(0);
    const [contar1, setContar1] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [contar5, setContar5] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [usuarioH, setUsuarioH] = useState();
    const [persona, setPersona] = useState();
    const [organizacion, setOrganizacion] = useState();
    const [configCome, setConfigCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [pagow, setPagow] = useState();
    const [retencion, setRetencion] = useState();
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [permiso, setPermiso] = useState();

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idusuario.includes(target.value)
                            || x.login.toLowerCase().includes(target.value.toLowerCase())
                            || (x.nombres + ' ' + x.apellidos).toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }


    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setPermiso(JSON.parse(localStorage.getItem('permisos')).accusuariocome);
        setFechaSistema(obj.fechasistema);
        setIdUsuario(obj.idusuario);
        setEspiritu(obj.espiritu);
        seleccionarUsuarios();
        /*seleccionarStatus();
        seleccionarConfiguracion();*/


    }, []);

    const SelectUsuario = (idusuario) => {

        let endpoint = `${op.conexion}/api/comun/selectusuario?idusuario=${idusuario}`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.idusuario > 0) {
                    setPersona({ cedula: response.data.cedula, nombres: response.data.nombres, apellidos: response.data.apellidos, correoe: response.data.correoe, tlf1: response.data.tlf1, tlf2: response.data.tlf2, fnacimiento: response.data.fnacimiento, nacionalidad: response.data.nacionalidad, sexo: response.data.sexo, direccion: response.data.direccionp });
                    setUsuarioH(response.data);
                    setMostrar5(true);
                } else {
                    setTitulo('Error');
                    setMsg('error al cargar el usuario');
                    setMostrar(true);
                    setActivate(false);
                }

            }


        }).catch((error) => {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const agregarUsuario = () => {
        setOperacion(1);
        setUsuarioH();
        setUsuariow();
        setPersona();
        setDeshabilitado(false);
        setMostrar5(true);
    };

    const cambiarClave = () => {
        setMostrar2(true);
    };

    const cerrarModalActualizar = () => {

        setUsuarioH();
        setUsuariow();
        setPersona();
        setMostrar5(false);
        renderizar();
        //window.location.href = '/comercio'
    }

    const validarActuUsuario = () => {
        /*setDesde(2);*/
        //setIdEmpresa(txtId);
        if (operacion === 4) {
            setUsuarioH();
            setMostrar5(false);
            return;
        }
        if (operacion === 1) {
            setIdUsuarioH(0);
        }
        /*alert(JSON.stringify(come));
        alert(JSON.stringify(repre));
        alert(JSON.stringify(actixcome));*/

        /*setComerAct(come);
        setRepreAct(repre);
        setActixComeAct(actixcome);
        setOperaPer(operacionPer);
        setMostrar4(true);*/
        setUsuarioH();
        setUsuariow();
        setPersona();
        setMostrar5(false);
        window.location.href = '/usuariosHacienda';
    }

    const handleCloseMensa = () => {
        setMostrar(false);
        if (contar3 > 0) {
            window.location.href = '/comercio'
            //renderizar();
        }
    }

    const handleCloseClave = () => {
        setMostrar2(false);
    }


    const renderizar = () => {
        seleccionarUsuarios();
    }

    const seleccionarUsuarios = () => {
        setContar4(0);
        setContar(0);
        setActivate(true);
        
        let endpoint = `${op.conexion}/api/comun/getallusuarios`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {
                    setRecords(response.data);
                    setContar4(contar4 + 1);
                    setActivate(false);
                } else {
                    setRecords([]);
                }
            }

            setActivate(false);

        }).catch((error) => {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })
        //selectUsu();
    };

    const consultarUsuario = (id, index) => (event) => {
        event.preventDefault();
        setDeshabilitado(true);
        setOperacion(4);
        //setIdComercio(recordsAfterPagingAndSorting()[index].idefiscal);
        setIdUsuarioH(id);
        setContar(0);
        setContar1(0);
        setContar5(0);
        setActivate(true);
        SelectUsuario(id);
    };

    const editarUsuario = (id, index) => (event) => {
        event.preventDefault();
        setDeshabilitado(false);
        setOperacion(2);
        //setIdComercio(recordsAfterPagingAndSorting()[index].idefiscal);
        setIdUsuarioH(id);
        setContar(0);
        setContar1(0);
        setContar5(0);
        setActivate(true);
        SelectUsuario(id);
        //setMostrar5(true);
    };

    const eliminarUsuario = (id, index) => (event) => {
        event.preventDefault();
        if (idUsuario === id) {
            setTitulo("Error");
            setMsg("El Usuario no se puede eliminar porque esta logueado");
            setMostrar(true);
            return;
        }
        setDeshabilitado(true);
        setOperacion(3);
        //setIdComercio(recordsAfterPagingAndSorting()[index].idefiscal);
        setIdUsuarioH(id);
        setContar(0);
        setContar1(0);
        setContar5(0);
        setActivate(true);
        SelectUsuario(id);
        //setMostrar5(true);
    };


    return (
        <div className="card">
            <ActualizarUsuario
                show={mostrar5} titulo={titulo1} mensaje={msg1}
                onHideCancela={cerrarModalActualizar}
                onHideAcepta={validarActuUsuario}
                usuario={usuarioH}
                datospersonales={persona}
                deshabilitado={deshabilitado ? deshabilitado : undefined}
                ingresa={0}
                declaweb={configCome ? configCome[0].declaweb.toString() : 'false'}
                idusuario={idUsuario}
                operacion={operacion}
            />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <CambiarClave
                show={mostrar2}
                onHide={handleCloseClave} />

            {/* /.card-header */}
            <div className="card amanecergris">
                <div className="card-body" >
                <div className="col-md-12 second-text py-2" style={{fontFamily:' Times New Roman, Times, serif'}}>
            <h3 className="p-0 m-0">Usuarios</h3>
            <hr className="w-50" style={{padding:0,margin:0}} />
          </div>
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                <div className="row d-flex justify-content-between">
                                    <div className="col-md-3">
                                        <input className="form-control search-input form-control-sm rounded-pill mr-sm-2" style={{ border: '1px solid #007bff' }} type="search" placeholder="Buscar" onChange={handleSearch} aria-label="Search" />
                                    </div>
                                 
                                    <div className="col-md-4 d-flex justify-content-end">
                                        <button disabled={permiso && permiso.substring(1, 2) !== "1" && permiso.substring(2, 3) !== "1"} onClick={cambiarClave} style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary rounded-pill mx-1"><i className="fas fa-key"> Cambiar Clave</i> </button>
                                    
                                        <button disabled={permiso && permiso.substring(1, 2) !== "1"} onClick={agregarUsuario} style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary rounded-pill mx-1"><i className="fa fa-user-plus"> Agregar Usuario</i> </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idcomercio} style={{ padding: "0" }}>
                                                    <td  className='align-baseline' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.idusuario}</td>
                                                    <td  className='align-baseline' style={{ fontSize: "10px", textAlign: "left", width: "80px" }}>{item.login}</td>
                                                    <td  className='align-baseline' style={{ fontSize: "10px", textAlign: "left", width: "80px" }}>{item.nombres + ' ' + item.apellidos}</td>
                                                    <td align="center"  className='align-baseline' style={{ fontSize: "10px", textAlign: "center", width: "180px", padding: 0 }}>
                                                        <button style={{pointerEvents: permiso && permiso.substring(0, 1) !== "1" ? 'none' : '' }} onClick={consultarUsuario(item.idusuario, index)} className="btn btn-sm btn-info rounded-circle"><i className="fas fa-eye"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button style={{pointerEvents: permiso && permiso.substring(2, 3) !== "1" ? 'none' : '' }} onClick={editarUsuario(item.idusuario, index)} className="btn btn-sm btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button style={{pointerEvents: permiso && permiso.substring(3, 4) !== "1" ? 'none' : '' }} onClick={eliminarUsuario(item.idusuario, index)} className="btn btn-sm btn-danger rounded-circle"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <TblPagination />

                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    );

}

export default TablaUsuarioHacienda;
